import $ from 'jquery';
import 'jquery-mask-plugin';

$(() => {

  const mask = 'FF:FF:FF:FF:FF:FF';
  const maskParams = {
    translation: {"F": {pattern: "[0-9a-fA-F]"}},
    onKeyPress: (str, e, obj) => $(obj).val(str.toUpperCase())
  };


  /**
   * Add a new MAC address field to the form
   */
  $('body.resource_item form').on('click', '.add_mac_fields', event => {
    event.preventDefault();
    const $macAddressRows = $('.mac_address_row:visible');
    const target = $(event.target);

    if ($macAddressRows.length < 8) {
      const time = new Date().getTime();
      const regexp = new RegExp(target.data('id'), 'g');
      const lastfield = target.closest('.control-group').children('.mac_address_row').last();
      lastfield.after(target.data('fields').replace(regexp, time));
    }

    if ($macAddressRows.length > 7) {
      $('.add_mac_fields').addClass('disabled');
    }

    // ugly duplication, must find better way
    const newfield = target.closest('.control-group').children('.mac_address_row').last();
    newfield.find('.sorting').val(
      Math.max.apply(Math,
        newfield.closest('form')
          .find('.mac_address_row:visible .sorting')
          .map((i, el) => parseInt($(el).val()) || 0))
      + 10);

    // Format MAC new address input fields
    newfield.find('.macaddress')
      .mask(mask, maskParams)
      .focus();
  });


  /**
   * Remove mac address from form.
   */
  $('body.resource_item form').on('click', '.remove_mac_fields', event => {
    $(event.target).prev('input[type=hidden]').val('1');
    $(event.target).closest('.mac_address_row').hide();
    if ($('.mac_address_row:visible').length < 8) {
      $('.add_mac_fields').removeClass('disabled');
    }
    event.preventDefault();
  });

});
